module.exports = __webpack_public_path__ + "img/pivo.adddb40d.jpg";